import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';
import { type FC, memo } from 'react';

type IconVariant = 'dark' | 'light' | 'white' | 'coloredLight' | 'coloredDark';

interface Props {
  variant: IconVariant;
}

const mainPathFill: { [Variant in IconVariant]: string } = {
  dark: '#323232',
  light: '#B8C7CE',
  white: '#FFF',
  coloredLight: '#FFF',
  coloredDark: '#323232',
};

const circleStroke: { [Variant in IconVariant]: string } = {
  dark: '#323232',
  light: '#B8C7CE',
  white: '#FFF',
  coloredLight: '#66B2FF',
  coloredDark: '#66B2FF',
};

const circleFill: { [Variant in IconVariant]: string } = {
  dark: 'none',
  light: 'none',
  white: 'none',
  coloredLight: '#66B2FF',
  coloredDark: '#66B2FF',
};

const BareNetworkViewerIcon: FC<SvgWrapperProps & Props> = ({
  variant,
  ...props
}) => (
  <SvgWrapper height='20' viewBox='0 0 20 20' width='20' {...props}>
    {}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      fill={mainPathFill[variant]}
      d='M16,13.05V9.11h-3V6.98c1.14-0.23,2-1.24,2-2.45 c0-1.38-1.12-2.5-2.5-2.5c-1.38,0-2.5,1.12-2.5,2.5c0,1.21,0.86,2.22,2,2.45v2.13H5V6.98c1.14-0.23,2-1.24,2-2.45 c0-1.38-1.12-2.5-2.5-2.5C3.12,2.03,2,3.15,2,4.53c0,1.21,0.86,2.22,2,2.45v3.13h3v2.94c-1.14,0.23-2,1.24-2,2.45 C5,16.88,6.12,18,7.5,18c1.38,0,2.5-1.12,2.5-2.5c0-1.21-0.86-2.22-2-2.45v-2.94h7v2.94c-1.14,0.23-2,1.24-2,2.45 c0,1.38,1.12,2.5,2.5,2.5c1.38,0,2.5-1.12,2.5-2.5C18,14.29,17.14,13.28,16,13.05z M3,4.53c0-0.83,0.67-1.5,1.5-1.5S6,3.7,6,4.53 s-0.67,1.5-1.5,1.5S3,5.35,3,4.53z M9,15.5C9,16.33,8.33,17,7.5,17S6,16.33,6,15.5S6.67,14,7.5,14S9,14.67,9,15.5z M11,4.53 c0-0.83,0.67-1.5,1.5-1.5S14,3.7,14,4.53s-0.67,1.5-1.5,1.5S11,5.35,11,4.53z M15.5,17c-0.83,0-1.5-0.67-1.5-1.5s0.67-1.5,1.5-1.5 s1.5,0.67,1.5,1.5S16.33,17,15.5,17z'
    />
    <circle
      cx='4.5'
      cy='4.5'
      r='2'
      stroke={circleStroke[variant]}
      fill={circleFill[variant]}
    />
    <circle
      cx='12.5'
      cy='4.5'
      r='2'
      stroke={circleStroke[variant]}
      fill={circleFill[variant]}
    />
    <circle
      cx='7.5'
      cy='15.5'
      r='2'
      stroke={circleStroke[variant]}
      fill={circleFill[variant]}
    />
    <circle
      cx='15.5'
      cy='15.5'
      r='2'
      stroke={circleStroke[variant]}
      fill={circleFill[variant]}
    />
  </SvgWrapper>
);
export const NetworkViewerIcon = memo(BareNetworkViewerIcon);
